import * as Yup from "yup";

import { Button, Card, Col, Row } from "@themesberg/react-bootstrap";
import { CountryDropdown, RegionDropdown } from "react-country-region-selector";
import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

import { ConnectedFocusError } from "focus-formik-error";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import Select from "react-select";
import TextError from "../TextError";
import ToolTip from "../ToolTip";
import { faClipboard } from "@fortawesome/free-solid-svg-icons";
import { getCustomerList } from "../master/AllUserDropDown";
import { postDealerEntry } from "../../Service/AllDealerEntryAPI";
import { validateUserName,validateEmail,validateMobileNo} from "./AllValidation";
import { selectSitetype } from "../SelectOption";
import swal from "sweetalert";

// import { validateEmail, validateMobileNo, validateUserName, } from "./AllValidation";

const phoneRegEx = "^([0|+[0-9]{1,5})?([7-9][0-9]{9})$"; //validate Phone No
const pincodeRegEx = "^[1-9]{1}[0-9]{2}[0-9]{3}$"; //validate PinCode

/* ----- declaration of validationSchema validation (based on the object schema provided by Yup) and display
  of validation errors ----- */
const validationSchema = Yup.object().shape({
  customerName: Yup.string().required("Required *"),
  dealerName: Yup.string()
    .required("Required *")
    .matches(/^[A-Za-z\s]+$/, "Enter only alphabets")
    .min(2, "Too Short!"),
  dealerShipName: Yup.string() .required("Required *")
  .matches(/^[A-Za-z\s]+$/, "Enter only alphabets")
  .min(2, "Too Short!"),
  mobileNo: Yup.string()
    .required("Required *")
    .matches(/^[0-9\s]+$/, "Enter Numbers Only")
    .test("valid-phone", "Invalid Mobile number", (value) => {
      if (!value) return false;
      const cleanedNumber = value.replace(/\s/g, "");
      return /^\d{10}$/.test(cleanedNumber);
    })
    .matches(/^\d{10}$/, "Mobile Number must be 10 digits")
    .matches(phoneRegEx, "Mobile number is not valid"),
  email: Yup.string()
    .required("Required *")
    .email("Invalid email")
    .test("com", "Email must include .com", (value) => {
      if (value && !value.includes(".com")) {
        return false;
      }
      return true;
    }),
  userName: Yup.string()
    .required("Required *")
    .matches(/^[A-Za-z\s]+$/, "Enter only alphabets")
    .min(2, "Too Short!"),
  password: Yup.string()
    .required("Required *")
    .min(8, "Password must be 8 characters long")
    .matches(/[0-9]/, "Must contain at least 1 digit (0-9)")
    .matches(/[a-z]/, "Must contain at least 1 lowercase letter (a-z)")
    .matches(/[A-Z]/, "Must contain at least 1 uppercase letter (A-Z)")
    .matches(/[^\w]/, "Must contain at lease 1 symbol"),
  city: Yup.string() .required("Required *")
  .matches(/^[A-Za-z\s]+$/, "City must only contain alphabets"),
  pinCode: Yup.string()
    .required("Required *")
    .matches(/^\d{6}$/, "Pincode must be 6 digits")
    .matches(pincodeRegEx, "Pincode is not valid"),
  address: Yup.string().required("Required *"),
  siteType: Yup.string().required("Required *"),
  desc: Yup.string()
    .required("Required *")
    .min(4, "It should have minimum 4 characters!")
    .max(225, "It should have maximum 225 characters!"),
});

export default () => {
  const [country, setCountry] = useState("India");
  const [state, setState] = useState("");
  const [customerName, setCustomerName] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [isLoaded, setisLoaded] = useState(false);
  const [eyePass, setEyePass] = useState(false);

  const eyeTogglePass = () => {
    setEyePass(!eyePass);
  };

  useEffect(() => {
    // ----- Function call to get customers, Dealers and  Service Engineers list
    getCustomersList();
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", function (event) {
      if (event.keyCode === 13 && event.target.nodeName === "INPUT") {
        var form = event.target.form;
        var index = Array.prototype.indexOf.call(form, event.target);
        form.elements[index + 1].focus();
        event.preventDefault();
      }
    });
  }, []);

  // ----- Function declaration of get customers list
  const getCustomersList = async () => {
    await getCustomerList().then((result) => {
      setCustomerName(result);
    });
  };

  return (
    <Formik
      // ----- declaration of initialValues
      initialValues={{
        dealerName: "",
        customerName: "",
        dealerShipName: "",
        mobileNo: "",
        email: "",
        userName: "",
        password: "",
        city: "",
        pinCode: "",
        address: "",
        siteType: "",
        desc: "",
      }}
      validationSchema={validationSchema}
      onSubmit={async (values, { resetForm }) => {
        // ----- declaration of onSubmit callback
        setisLoaded(true);
        try {
          // ----- code that we will 'try' to run
          const loginUserName = sessionStorage.getItem("userName");
          const loginRole = sessionStorage.getItem("role");
          // ----- Object to add dealer data
          const data = {
            dealerName: values.dealerName
              .toLowerCase()
              .split(" ")
              .map((word) => word.trim())
              .filter((word) => word !== "")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" ")
              .trimStart()
              .trimEnd(),
            fkCustomerId: selectedCustomer,
            customerName: values.customerName,
            dealerShipName: values.dealerShipName,
            userName: values.userName
              .toLowerCase()
              .split(" ")
              .map((word) => word.trim())
              .filter((word) => word !== "")
              .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
              .join(" ")
              .trimStart()
              .trimEnd(),
            mobileNo: values.mobileNo,
            email: values.email.toLowerCase(),
            country: country,
            state: state,
            city: values.city,
            pinCode: values.pinCode,
            address: values.address,
            siteType: values.siteType,
            discription: values.desc,
            password: values.password,
            role: "dealer",
            createdBy: `${loginUserName}`,
          };
          console.log("Dealer Data", data);
          setTimeout(async () => {
            const token = sessionStorage.getItem("token");
            const headers = { Authorization: `Bearer ${token}` };
            await postDealerEntry(data, headers)
              .then((result) => {
                setisLoaded(false);
                console.log("Dealer Result", result);
                
                if (result.data.message === "mobile no already exist") {
                  swal("Failed", "Registered Mobile No already exists", "warning");
                } else if (result.data.message === "email-id already exists") {
                  swal("Failed", "Email ID already exists", "warning");
                } else if (result.data.message === "username already exist") {
                  swal("Failed", "Username already exists", "warning");
                } else {
                  swal("Great", "Dealer user created successfully...", "success");
                  resetForm();
                }
                
                // swal("Great", "Dealer is created successfully", "success");
              })
              .catch((error) => {
                console.log("Dealer Error", error);
                setisLoaded(false);
                if (error.response.status === 400) {
                  console.log("error.response.data :-", error.response.data);
                  let dealerVal = error?.response?.data;
                  if (dealerVal?.dealerName !== undefined) {
                    swal("Failed", "Please Enter dealer name", "warning");
                    return false;
                  }
                  if (dealerVal?.dealerShipName !== undefined) {
                    swal("Failed", "Please Enter DealerShip name", "warning");
                    return false;
                  }
                  if (dealerVal?.userName !== undefined) {
                    swal("Failed", "Please Enter User Name", "warning");
                    return false;
                  }
                  if (dealerVal?.address !== undefined) {
                    swal("Failed", "Please Enter address", "warning");
                    return false;
                  }
                  if (dealerVal?.city !== undefined) {
                    swal("Failed", "Please Enter city", "warning");
                    return false;
                  }
                  if (dealerVal?.country !== undefined) {
                    swal("Failed", "PLease Select Country", "warning");
                    return false;
                  }
                  if (dealerVal?.discription !== undefined) {
                    swal("Failed", "Please Enter description", "warning");
                    return false;
                  }
                  if (dealerVal?.email !== undefined) {
                    swal("Failed", "Please Enter email", "warning");
                    return false;
                  }
                  if (dealerVal?.mobileNo !== undefined) {
                    swal("Failed", "Please Enter Mobile Number", "warning");
                    return false;
                  }
                  if (dealerVal?.password !== undefined) {
                    swal("Failed", "Please Enter Password", "warning");
                    return false;
                  }
                  if (dealerVal?.pinCode !== undefined) {
                    swal("Failed", "Please Enter PinCode", "warning");
                    return false;
                  }
                  if (dealerVal?.siteType !== undefined) {
                    swal("Failed", "Please Enter Site Type", "warning");
                    return false;
                  }
                  if (dealerVal?.state !== undefined) {
                    swal("Failed", "Please Select State", "warning");
                    return false;
                  }
                } else {
                  swal(
                    "Failed",
                    "Something went wrong please check your internet",
                    "error"
                  );
                }
              });
          }, 200);
        } catch (error) {
          // ----- code to run if there are any problems
          console.log(error);
          setisLoaded(false);
          swal(
            "Failed",
            "Something went wrong please check your internet",
            "error"
          );
        }
      }}
    >
      {(formik) => {
        // ----- Formik provides the Form, Field and ErrorMessage
        const { isValid, dirty, isSubmitting } = formik;
        const isbuttondisable = state && country;
        return (
          <>
            {isLoaded ? (
              <div className="reportload"></div>
            ) : (
              <>
                <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                  <div className="d-flex">
                    <Link
                      to="dealer-entry-report"
                      className="fieldLink btn btn-primary"
                    >
                      <FontAwesomeIcon icon={faClipboard} className="me-2" />{" "}
                      Reports
                      <span className="icon icon-small ms-1"></span>
                    </Link>
                  </div>
                </div>
                <Card border="light" className="bg-white shadow-sm mb-4">
                  <Card.Body>
                    <h5 className="head mb-4">New Dealer Entry Form</h5>
                    {/* ----- react-final-form ----- */}
                    <Form>
                      <ConnectedFocusError />
                      <Row>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              Dealer Name *
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Dealer Name (Only alphabets allowed)"
                                direction="bottom"
                              >
                                <Field
                                  type="text"
                                  className="form-control"
                                  name="dealerName"
                                  placeholder="Enter Dealer Name"
                                  autoComplete="off" 
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="dealerName"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              Customer Name *
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Select Customer Name"
                                direction="bottom"
                              >
                                <Select
                                  placeholder="Select Customer Name"
                                  title="Select Customer Name "
                                  options={customerName}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "customerName",
                                      e.value
                                    );
                                    setSelectedCustomer(e.id);
                                  }}
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="customerName"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              Dealership Name *
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Dealership Name"
                                direction="bottom"
                              >
                                <Field
                                  type="text"
                                  className="form-control"
                                  name="dealerShipName"
                                  placeholder="Enter Dealership Name"
                                  autoComplete="off" 
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="dealerShipName"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">Username *</label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Username"
                                direction="bottom"
                              >
                                <Field
                                  type="text"
                                  className="form-control"
                                  name="userName"
                                  placeholder="Enter Username"
                                  autoComplete="off" 
                                  validate={validateUserName}
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="userName"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">Password *</label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter 8 digit password"
                                direction="bottom"
                              >
                                <Field
                                  type={eyePass ? "text" : "password"}
                                  className="form-control"
                                  name="password"
                                  placeholder="Enter Password"
                                />
                              </ToolTip>
                            </div>
                            <span className="p-eye1" onClick={eyeTogglePass}>
                              <FontAwesomeIcon
                                icon={eyePass ? faEyeSlash : faEye}
                              />
                            </span>
                            <ErrorMessage
                              name="password"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">Email *</label>
                            <div className="example-wrapper">
                              <ToolTip content="Enter Email" direction="bottom">
                                <Field
                                  type="email"
                                  className="form-control"
                                  name="email"
                                  placeholder="Enter Email"
                                  autoComplete="off" 
                                  validate={validateEmail}
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage name="email" component={TextError} />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              Dealer Mobile No. *
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Dealer Mobile No"
                                direction="bottom"
                              >
                                <Field
                                  type="text"
                                  maxLength="10"
                                  className="form-control"
                                  name="mobileNo"
                                  placeholder="Enter Dealer Mobile No."
                                  autoComplete="off" 
                                  validate={validateMobileNo}
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="mobileNo"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">Site Type *</label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Select Site Type"
                                direction="bottom"
                              >
                                <Select
                                  placeholder="Please Select Site Type"
                                  options={selectSitetype}
                                  onChange={(e) => {
                                    formik.setFieldValue("siteType", e.value);
                                  }}
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="siteType"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">Country </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Select Country"
                                direction="bottom"
                              >
                                <CountryDropdown
                                  className="form-control"
                                  value={country}
                                  onChange={(val) => setCountry(val)}
                                  priorityOptions={["IN"]}
                                />
                              </ToolTip>
                            </div>
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">State </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Select State"
                                direction="bottom"
                              >
                                <RegionDropdown
                                  className="form-control"
                                  id="state"
                                  country={country}
                                  value={state}
                                  onChange={(val) => setState(val)}
                                />
                              </ToolTip>
                            </div>
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">City *</label>
                            <div className="example-wrapper">
                              <ToolTip content="Enter City" direction="bottom">
                                <Field
                                  type="text"
                                  className="form-control"
                                  name="city"
                                  placeholder="Enter City"
                                  autoComplete="off" 
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage name="city" component={TextError} />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">Pin Code *</label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Pin Code"
                                direction="bottom"
                              >
                                <Field
                                  type="text"
                                  className="form-control"
                                  name="pinCode"
                                    maxLength="6"
                                  placeholder="Enter Pin Code"
                                  autoComplete="off" 
                                  // maxLength="6"
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="pinCode"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">Address *</label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Address"
                                direction="bottom"
                              >
                                <Field
                                  as="textarea"
                                  rows="2"
                                  className="form-control"
                                  maxLength={100}
                                  name="address"
                                  placeholder="Enter Address"
                                  autoComplete="off" 
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="address"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              Description *
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Description"
                                direction="bottom"
                              >
                                <Field
                                  as="textarea"
                                  rows="3"
                                  maxLength={100}
                                  className="form-control"
                                  name="desc"
                                  placeholder="Enter Description"
                                  autoComplete="off" 
                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage name="desc" component={TextError} />
                          </div>
                        </Col>
                      </Row>
                      <div className="mt-3">
                        <Button
                          variant="primary"
                          type="submit"
                          disabled={!(formik.isValid && formik.dirty) || formik.isSubmitting || !isbuttondisable}
                        >
                          Create Dealer
                        </Button>
                      </div>
                    </Form>
                  </Card.Body>
                </Card>
              </>
            )}
          </>
        );
      }}
    </Formik>
  );
};
